import { t2s } from "chinese-s2t";

const specialCharMap: Record<string, string> = {
  徵: "征",
  鬆: "松",
  隻: "只",
  幹: "干",
  麼: "么",
  裏: "里",
  鬥: "斗",
  繫: "系",
  佈: "布",
  製: "制",
  註: "注",
  陞: "升",
  嫺: "娴",
  託: "托",
  衝: "冲",
  閲: "阅",
  釐: "厘",
  係: "系",
  鑽: "钻",
  週: "周",
  為: "为",
  爲: "为",
  達: "达",
  逹: "达",
  餘: "余",
  衛: "卫",
  簽: "签",
  鑑: "鉴",
  籤: "签",
  恆: "恒",
  証: "证",
  證: "证",
  認: "认",
};

export function t2sWithCharMap(text: string): string {
  for (const [trad, simp] of Object.entries(specialCharMap)) {
    text = text.replaceAll(trad, simp);
  }
  return t2s(text);
}
